import { render } from "./RingSelectorDialog.vue?vue&type=template&id=4de33287&scoped=true"
import script from "./RingSelectorDialog.vue?vue&type=script&lang=js"
export * from "./RingSelectorDialog.vue?vue&type=script&lang=js"

import "./RingSelectorDialog.vue?vue&type=style&index=0&id=4de33287&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de33287"]])

export default __exports__